class TreffenHeader {
  constructor() {
    this.group = document.querySelector('.shopify-section-group-header-group');
    this.headerSection = document.querySelector('.section-header');
    if (!this.group || !this.headerSection) return;

    this.wrapper = this.headerSection.querySelector('.header-wrapper');

    this.onScroll = this.onScroll.bind(this);
    this.setHeights = this.setHeights.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.setHeights);

    this.setHeights();
    this.onScroll();
  }

  setHeights() {
    const announcement = this.group.querySelector('.announcement-bar-section');
    const announcementHeight = announcement ? announcement.offsetHeight : 0;
    const headerHeight = this.headerSection ? this.headerSection.offsetHeight : 0;

    document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--treffen-header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--header-group-height', `${announcementHeight + headerHeight}px`);
  }

  onScroll() {
    const scrolled = window.scrollY > 20;

    if (this.wrapper) {
      this.wrapper.classList.toggle('header-wrapper--scrolled', scrolled);
    }

    this.headerSection.classList.toggle('section-header--stuck', scrolled);
  }
}

const initTreffenHeader = () => {
  if (!window.__treffenHeader) {
    window.__treffenHeader = new TreffenHeader();
  } else {
    window.__treffenHeader.setHeights();
    window.__treffenHeader.onScroll();
  }
};

document.addEventListener('DOMContentLoaded', initTreffenHeader);
window.addEventListener('load', initTreffenHeader);
